import AttendanceSerializer from './base';

export default class ResponseActivity extends AttendanceSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      notes: '',
      detail: '',
      responseActivity: 0,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
